import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox, CircularProgress } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { login } from '../../../store/authSlice';
// components
import Iconify from '../../../components/iconify';

// -----------------------------------------------------------------------

export default function LoginForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {loading} = useSelector(state => state.auth)
  console.log(loading)

  const [showPassword, setShowPassword] = useState(false);

  const [values, setValeus] = useState({
    phone: "",
    password: "",
    fcm_token: "666"
  })

  const handleChange = (e) => {
    setValeus(prev => ({
      ...prev,
      [e.target.name] : e.target.value
    }))
  }


  const handleClick = () => {
    dispatch(login(values))
    .then(res => {
      if(res.payload.status){
        setValeus({
          phone: "",
          password: "",
          fcm_token: "666"
        })
        navigate('/dashboard/app', { replace: true });
      }
    })
  };

  return (
    <>
      <Stack spacing={3}>
        <TextField name="phone" label="Phone Number" value={values.phone} onChange={handleChange} />

        <TextField
          name="password"
          label="Password"
          value={values.password}
          onChange={handleChange}
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleClick} sx={{my: 2}}>
        {loading ? <CircularProgress sx={{color: "#fff"}} /> : "Login"}
      </LoadingButton>
    </>
  );
}
